import { Theme } from '@mui/material';

const ESPESSURA = 28;

// Moldura suave da área de conteúdo: fio fino + brilho que apaga em direção ao
// centro, nas quatro bordas. É só `background` do <main> (preso à janela, não
// rola com a página) — de propósito sem camada/pseudo-elemento: `isolation` no
// <main> prenderia as telas de bloqueio (TelaBloqueioSalvando etc., que são
// fixed lá dentro) abaixo do menu lateral.
//
// `esquerda`: onde a área de conteúdo começa (largura do menu).
// `inferior`: altura que fica coberta embaixo (barra de navegação do celular).
export const molduraDeFundoSx = (theme: Theme, esquerda = 0, inferior = 0) => {
  const { fio, brilho } = theme.torq.moldura;
  const faixa = (direcao: string) =>
    `linear-gradient(${direcao}, ${fio} 0, ${fio} 1px, ${brilho} 1px, transparent ${ESPESSURA}px)`;

  return {
    backgroundImage: [faixa('180deg'), faixa('0deg'), faixa('90deg'), faixa('270deg')].join(', '),
    backgroundRepeat: 'no-repeat',
    backgroundAttachment: 'fixed',
    backgroundSize: `100% ${ESPESSURA}px, 100% ${ESPESSURA}px, ${ESPESSURA}px 100%, ${ESPESSURA}px 100%`,
    backgroundPosition: `${esquerda}px 0, ${esquerda}px calc(100% - ${inferior}px), ${esquerda}px 0, 100% 0`,
  };
};
